import { AxiosResponse } from 'axios';
import { BehApiRoutes, behClient } from '../beh-api';

interface IAttachmentDownloadGet {
  downloadAttachment: (
    caseId: string,
    submissionId: string,
    attachmentId: string
  ) => Promise<AxiosResponse<Blob, any>>;
}

export function useAttachmentDownloadGet(): IAttachmentDownloadGet {
  const downloadAttachment = async (
    caseId: string,
    submissionId: string,
    attachmentId: string
  ) =>
    behClient.get(
      BehApiRoutes.attachmentByIdAndSubmission(
        caseId,
        submissionId,
        attachmentId
      ),
      {
        headers: {
          Accept: 'application/octet-stream'
        },
        responseType: 'blob'
      }
    );

  return { downloadAttachment };
}
